import React from "react";
import { Dropdown, Button } from "antd";
import { chevronDown } from "ionicons/icons";
import { IonIcon } from "@ionic/react";

const ActionBtn = ({ options = [], onClick }) => {
  return (
    <Dropdown
      menu={{
        items: options,
        onClick: ({ key }) => {
          onClick(key);
        },
      }}
    >
      <Button type="primary" size="large" style={{ marginRight: "8px" }}>
        Action <IonIcon icon={chevronDown} />
      </Button>
    </Dropdown>
  );
};

export default ActionBtn;
